<template>
  <div class="flex items-end">
    <RevRating :score size="extra-small" />
    <!-- mt-1 md:mt-2 matches RevRating's internal score label margin (SR-5918 local fix).
         Remove once RevRating supports a static rating count natively. -->
    <span class="text-static-default-hi caption ml-4 mt-1 md:mt-2">
      ({{ i18n.number(count) }})
    </span>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevRating } from '@ds/components/Rating'

defineProps<{
  score: number
  count: number
}>()

const i18n = useI18n()
</script>
